"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _find2 = _interopRequireDefault(require("lodash-es/find"));

var _get2 = _interopRequireDefault(require("lodash-es/get"));

var _context = require("../../context");

var _heading = _interopRequireDefault(require("../../atoms/heading"));

var _components = require("./_components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SLIDER = 'slider';
var TABS_CONTAINER = 'tabsContainer';
var TABS = 'tabs';
var sizes = {
  height: {
    small: '32px',
    medium: '40px',
    large: '48px'
  },
  contentSize: {
    small: 4,
    medium: 3,
    large: 2
  }
};

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tabs).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "changeTab", function (changeToValue) {
      var selectedValue = _this.state.selectedTab;

      if (selectedValue !== changeToValue) {
        _this.setState({
          selectedTab: changeToValue
        }, function () {
          return _this.props.onChange(changeToValue);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "addRefs", function (type, el, index) {
      if (!el) return;

      if (type === TABS) {
        if (el && !_this.nodes[type][index]) {
          _this.nodes[type].push(el);
        }

        return;
      }

      if (type === TABS_CONTAINER && !_this.nodes[type]) {
        _this.nodes[type] = el;
        return;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getTabs", function () {
      var _this$props = _this.props,
          autoAlign = _this$props.autoAlign,
          minWidth = _this$props.minWidth,
          kind = _this$props.kind,
          version = _this$props.version,
          view = _this$props.view,
          background = _this$props.background,
          size = _this$props.size;
      var height = sizes.height[size];
      var contentSize = sizes.contentSize[size];
      var _this$state = _this.state,
          selectedTab = _this$state.selectedTab,
          tabs = _this$state.tabs,
          translateBy = _this$state.translateBy;
      var tabWidth = "".concat(100 / tabs.length, "%");
      var slider = view === SLIDER;
      var width = _this.tabWidth && _this.tabWidth * _this.state.totalTabs;
      return _react["default"].createElement(_components.TabsNavigation, {
        slider: slider,
        kind: kind,
        version: version,
        background: background,
        className: "tabs-nav",
        translateBy: translateBy,
        width: width ? width : null
      }, tabs.map(_this.renderTab, {
        changeTab: _this.changeTab,
        autoAlign: autoAlign,
        tabWidth: tabWidth,
        minWidth: minWidth,
        kind: kind,
        selectedTab: selectedTab,
        version: version,
        height: height,
        contentSize: contentSize,
        self: _assertThisInitialized(_this)
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "autoShift", function () {
      _this.nextBtnHandler(null, _this.state.selectedTabIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "previousBtnHandler", function () {
      var shiftBy = _this.props.shiftBy;

      _this.setState(function (prevState) {
        var prevTranslated = prevState.translateBy;

        if (prevTranslated === 0) {
          return _objectSpread({}, prevState);
        }

        if (prevTranslated + _this.tabWidth * shiftBy > 0) {
          return _objectSpread({}, prevState, {
            translateBy: 0
          });
        }

        return _objectSpread({}, prevState, {
          translateBy: prevTranslated + _this.tabWidth * shiftBy
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "nextBtnHandler", function (e) {
      var autoShiftBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var shiftBy = _this.props.shiftBy;
      var _this$state2 = _this.state,
          totalTabs = _this$state2.totalTabs,
          nodes = _this$state2.nodes;
      var tabs = nodes.tabs;
      var lastTab = tabs[totalTabs - 1];
      var tabsContainerRect = nodes.tabsContainer.getBoundingClientRect();
      var lastTabRect = lastTab.getBoundingClientRect(); //* return if the last element is already visible

      if (tabsContainerRect.right >= lastTabRect.right) {
        return;
      }
      /*
      * finding out the right side non visible elements
      */


      var nonVisibleElements = 0;
      tabs.forEach(function (el) {
        var rect = el.getBoundingClientRect();

        if (rect.left >= tabsContainerRect.right) {
          nonVisibleElements++;
        }
      });

      _this.setState(function (prevState) {
        var alreadyTranslated = prevState.translateBy;
        /*
        * Determining the count of by which the container needs to be translated
        * so that the last tab remains at the end of the container regardless of
        * the shiftBy choosen by the user
        */

        var shiftFactor = nonVisibleElements < shiftBy ? nonVisibleElements : shiftBy;
        /*
        * Auto shift if a tab is pre selected
        ! Note: if the selected tab has index greater than the number of visible elements
        ! then the preselected tab will be shown as the last tab
        */

        if (autoShiftBy) {
          shiftFactor = autoShiftBy + 1 - _this.visibleTabsCount;
        }

        return _objectSpread({}, prevState, {
          translateBy: alreadyTranslated - _this.tabWidth * shiftFactor
        });
      });
    });

    var _tabs = _react["default"].Children.map(props.children, function (child) {
      return {
        value: child.props.value,
        label: child.props.label,
        selected: child.props.selected
      };
    });

    var selectedTabIndex = 0;
    var selected = (0, _find2["default"])(_tabs, function (tab, index) {
      if (tab.selected) {
        selectedTabIndex = index;
        return tab.selected;
      }
    });

    var _selectedTab = (0, _get2["default"])(selected, 'value', _tabs[0].value);

    _this.state = {
      tabs: _tabs,
      // tabs as an object of value and label
      selectedTab: _selectedTab,
      selectedTabIndex: selectedTabIndex,
      totalTabs: _tabs.length,
      translateBy: 0 //  Translate factor : it cannot be greater than 0
      // object to keep the refrences of the dom elements

    };
    _this.nodes = {
      tabs: [],
      // all the tab nodes
      tabsContainer: null // node of the parent which holds all the tab elements

    };
    return _this;
  }

  _createClass(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.view === SLIDER) {
        //* width of single tab
        this.tabWidth = this.nodes.tabs[0].getBoundingClientRect().width; //* set the width of the tabs container as per the number of elements which are visible

        var container = this.nodes.tabsContainer;
        var containerWidth = container.getBoundingClientRect().width; //* Number of tabs which are visible at a time

        this.visibleTabsCount = parseInt(containerWidth / this.tabWidth, 10);
        /*
        * setting the container width as per the number of tabs visible
        * so as we don't see the tabs which are not supposed to be visible
        */

        this.containerWidth = this.tabWidth * this.visibleTabsCount;
        container.style.width = "".concat(this.containerWidth, "px");
        this.setState({
          nodes: _objectSpread({}, this.nodes)
        });
        /*
        * auto-shift to the preselected elemtent in case the selected index is more than the
        * number of elemnts visible
        */

        if (this.state.selectedTabIndex > 0 && this.visibleTabsCount <= this.state.selectedTabIndex) {
          /*
          * timeout is required as the state change is an async process
          *  and we need to wait till initial states changes are updated
          */
          this.autoShiftTimeOut = setTimeout(function () {
            _this2.autoShift();
          }, 20);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      /*
        * Best practice to clear timeout whenever if used
        */
      clearTimeout(this.autoShiftTimeOut);
    }
  }, {
    key: "renderTab",

    /*
    !@function
    * name: renderTab
    * Description: Function to render tabs
    * @param: props {object} : prop object passed as the context as this function works under the context of
    *                          pros object only ('this' do not refer to this component)
    *                          see the getTabs function for more info
    * @return {function} : composed function
    */
    value: function renderTab(_ref, index) {
      var value = _ref.value,
          label = _ref.label;
      var autoAlign = this.autoAlign,
          kind = this.kind,
          tabWidth = this.tabWidth,
          minWidth = this.minWidth,
          changeTab = this.changeTab,
          selectedTab = this.selectedTab,
          version = this.version,
          self = this.self,
          height = this.height,
          contentSize = this.contentSize;
      return _react["default"].createElement(_components.TabLink, {
        kind: kind,
        autoAlign: autoAlign,
        tabWidth: tabWidth,
        minWidth: minWidth,
        onClick: function onClick() {
          return changeTab(value);
        },
        key: value,
        selected: value === selectedTab,
        version: version,
        innerRef: function innerRef(el) {
          return self.addRefs(TABS, el, index);
        },
        height: height
      }, _react["default"].createElement(_heading["default"], {
        size: contentSize
      }, label));
    }
    /*
    !@function
    * name: getTabs
    * Description: Function to render Tabs and tabs container div
    * @return {React Component} : TabsNavigation
    */

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          view = _this$props2.view,
          version = _this$props2.version,
          background = _this$props2.background,
          kind = _this$props2.kind,
          size = _this$props2.size;
      var height = sizes.height[size];
      var selectedTab = this.state.selectedTab;
      var selectedTabContent = (0, _find2["default"])(children, {
        props: {
          value: selectedTab
        }
      });
      var showSelectedTabContent = selectedTabContent && selectedTabContent.props.children; //* Slider view

      if (view === SLIDER) {
        return _react["default"].createElement("div", null, _react["default"].createElement(_components.MainWrapper, {
          className: "tabs-slider",
          version: version,
          background: background,
          height: height
        }, _react["default"].createElement(_components.ArrowButton, {
          type: "left",
          onClick: this.previousBtnHandler
        }), _react["default"].createElement(_components.Wrapper, {
          slider: true,
          version: version,
          innerRef: function innerRef(el) {
            return _this3.addRefs(TABS_CONTAINER, el);
          }
        }, this.getTabs()), _react["default"].createElement(_components.ArrowButton, {
          type: "right",
          onClick: this.nextBtnHandler
        })), showSelectedTabContent && _react["default"].createElement(_components.SelectedTabContainer, {
          className: "selected-tab",
          kind: kind
        }, selectedTabContent));
      } //* Normal view


      return _react["default"].createElement("div", null, this.getTabs(), showSelectedTabContent && _react["default"].createElement(_components.SelectedTabContainer, {
        className: "selected-tab",
        kind: kind
      }, selectedTabContent));
    }
  }]);

  return Tabs;
}(_react["default"].Component);

Tabs.Tab = function (props) {
  return _react["default"].createElement(_components.TabContent, null, props.children);
};

Tabs.Tab.propTypes = {
  /** Unique identifier for a tab */
  value: _propTypes["default"].string.isRequired,

  /* Label for a tab */
  label: _propTypes["default"].string.isRequired,

  /** Selected by default? */
  selected: _propTypes["default"].bool
};
Tabs.propTypes = {
  /** Kind of Tabs. Local would be rendered with less paddings */
  kind: _propTypes["default"].oneOf(['local', 'global']),

  /** Children should be an array of Tabs.Tab */
  children: _propTypes["default"].arrayOf(_propTypes["default"].element).isRequired,

  /** Auto align as per parent's width */
  autoAlign: _propTypes["default"].bool,

  /** Min width at tab level */
  minWidth: _propTypes["default"].number,
  shiftBy: _propTypes["default"].number,

  /** Callback function to be called on tabChange [value of the selected tab will be sent] */
  onChange: _propTypes["default"].func,

  /** to get the background color  */
  background: _propTypes["default"].bool,

  /** Size of the tab */
  size: _propTypes["default"].oneOf(['small', 'medium', 'large']),

  /** A normal tab or a slider tab */
  view: _propTypes["default"].oneOf(['normal', 'slider'])
};
Tabs.defaultProps = {
  kind: 'global',
  children: [],
  autoAlign: false,
  minWidth: 5,
  size: 'medium',
  view: 'normal',
  shiftBy: 2,
  background: false,
  onChange: _noop2["default"]
};
Tabs.displayName = 'Tabs';

var _default = (0, _context.withVersion)(Tabs);

exports["default"] = _default;